import noImage from '../assets/img/No_Image_Available.jpg';
export function imagePath(image) {
    if (!image) return noImage;
    return `https://backend.glowthentic.store/${image}`;
}